import { cva } from 'class-variance-authority';

/** Class recipe of `Button`, shared with primitives that render their own element (alert dialog). */
export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default:
          'bg-primary text-primary-foreground shadow-xs shadow-primary/25 hover:bg-primary/90 hover:-translate-y-px',
        destructive:
          'bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60',
        outline:
          'border bg-background shadow-xs hover:border-primary/60 hover:bg-primary/5 hover:text-primary dark:bg-input/30 dark:border-input dark:hover:bg-primary/10 dark:hover:border-primary/60',
        secondary: 'bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80',
        ghost: 'hover:bg-primary/10 hover:text-primary',
        /** Row-level delete / remove (lists, tables, chart cards); dialogs confirm with `destructive`. */
        'ghost-destructive': 'text-destructive hover:bg-destructive/10 hover:text-destructive',
        link: 'text-primary underline-offset-4 hover:underline',
      },
      size: {
        default: 'h-9 px-4 py-2 has-[>svg]:px-3',
        sm: 'h-8 gap-1.5 px-3 has-[>svg]:px-2.5',
        lg: 'h-10 px-6 has-[>svg]:px-4',
        icon: 'size-9',
        'icon-sm': 'size-8',
        /** A link inside a sentence (with `variant="link"`): no height, no padding, the sentence's size. */
        inline: 'h-auto p-0 align-baseline text-[length:inherit]',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
